import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

import { SEGMENT } from '@root/app-routing.model';

@Component({
	selector: 'tacho-goodbye-page',
	templateUrl: './goodbye-page.component.html'
})
export class GoodbyePageComponent implements AfterViewInit {
	private readonly miliseconds: number = 3000;

	constructor(private readonly router: Router) {}

	ngAfterViewInit() {
		setTimeout(() => {
			this.router.navigate([`/${SEGMENT.CONNECT}`]);
		}, this.miliseconds);
	}

}
